import React, { FunctionComponent } from 'react';
import {
    BrowserRouter,
    Routes as RrdRoutes,
    Route,
    Navigate,
} from 'react-router-dom';

import { Routes } from './components/Routes';

const App: FunctionComponent = () => (
    <div className="App">
        <BrowserRouter>
            <RrdRoutes>
                <Route
                    path="noh/:language/*"
                    element={<Routes baseUrl="noh" />}
                />
                <Route
                    path="noh/"
                    element={<Navigate replace to="/noh/fr" />}
                />
                <Route path="/" element={<Navigate replace to="/noh/fr" />} />
            </RrdRoutes>
        </BrowserRouter>
    </div>
);

export default App;
